import { Component, OnInit } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'sc-generic-field',
  templateUrl: './generic-field.component.html',
  styleUrls: ['./generic-field.component.scss']
})
export class GenericFieldComponent extends FieldType implements OnInit {
  public customField;

  constructor() {
    super();
  }

  ngOnInit() {}
}
